import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import Link from '@alltrails/denali/components/Link';

const a1 = chunks => (
  <Link href="/terms" target="_blank" size="sm">
    {chunks}
  </Link>
);

const a2 = chunks => (
  <Link href="/privacy" target="_blank" size="sm">
    {chunks}
  </Link>
);

// https://www.figma.com/file/gZaqAej8HzoFkyrjlQ4cNs/Integrating-Brand-Changes?node-id=1571%3A79911
const TermsOfService = () => {
  return (
    <Typography color="secondary" component="div" variant="paragraph100">
      <FormattedMessage
        defaultMessage="By continuing to use AllTrails, you agree to our <a1>Terms of Service</a1> and <a2>Privacy Policy</a2>."
        values={{
          a1,
          a2
        }}
      />
    </Typography>
  );
};

export default TermsOfService;
